export default function csrfToken () {
  var m = document.querySelector('meta[name="csrf-token"]');
  if (m) {
    return m.getAttribute('content');
  }
  return null;
}
